// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"28cc0448","44":"10738faf","51":"55cb2e38","103":"e4169cb1","117":"e74efdf3","285":"3e53eefb","400":"593d99fe","432":"0bd574f1","437":"74429637","515":"b0bb20ee","521":"e4c2cd56","525":"2334a16f","638":"f15f1702","728":"5270726d","881":"710bf526","906":"0454277b"}[chunkId] + ".chunk.js";
};